import React, { useEffect } from "react";
import "particles.js"; // imports the particles.js script
import NavBar from "./NavBar";
import SplitText from "../components/SplitText";
import GradientText from "../components/GradientText";

import bg_immage from '../assets/images/gradient_bg2.png'

import bgImage from "../assets/images/student.png";

export default function ParticlesBackground() {
  useEffect(() => {
    window.particlesJS("particles-js", {
      particles: {
        number: { value: 160, density: { enable: true, value_area: 800 } },
        color: { value: "#ffffff" },
        shape: { type: "circle" },
        opacity: { value: 1, random: true },
        size: { value: 3, random: true },
        line_linked: { enable: false },
        move: { enable: true, speed: 1, random: true },
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: { enable: true, mode: "bubble" },
          onclick: { enable: true, mode: "repulse" },
        },
        modes: {
          bubble: { distance: 250, size: 6, duration: 2, opacity: 0.8 },
          repulse: { distance: 400, duration: 0.4 },
        },
      },
      retina_detect: true,
    });
  }, []);

  return (
    <div className="relative w-full min-h-screen overflow-hidden">
      {/* Particles background */}
      <div
  id="particles-js"
  className="absolute inset-0 bg-gray-100 z-0 bg-cover bg-center"
  style={{ backgroundImage: `url(${bg_immage})` }}
></div>


      {/* Navbar */}
      <NavBar />

      {/* Hero Section */}
      <div className="relative z-10 flex flex-col items-center justify-center px-6 md:px-12 lg:px-20 min-h-[calc(100vh-4rem)]">
  <section className="flex flex-col items-center justify-center w-full max-w-5xl mx-auto text-center">
    {/* Content Centered */}
    <div className="w-full">
      <GradientText colors={["#0A6E30", "#ffffff"]} showBorder>
        Afya Ustawi Foundation ✨
      </GradientText>

      <SplitText
        text="Take Control of Your Health Journey With Afya Ustawi Foundation"
        color="white"
        size="3rem"
        fontWeight="bold"
        tag="h1"
        useGradient={true}
        animateSplit={false}
        gradientColors={["#0A6E30", "#60efff", "#00ff87"]}
        from={{ opacity: 1, y: 40 }}
        className="mt-4 leading-snug"
      />

      <p className="text-gray-600 mt-6 mx-auto max-w-2xl font-light text-sm sm:text-base">
        Afya Ustawi Foundation operates across the Tanzania Mainland with
        a mandate to promote holistic well-being (ustawi kamili) that
        extends beyond the absence of disease to encompass physical,
        mental, social, economic, and environmental health.
      </p>

      <div className="mt-6 flex justify-center">
        <button className="px-6 py-3 w-auto bg-white text-green-600 font-medium rounded-full shadow-md hover:bg-indigo-100 transition">
          Get In Touch
        </button>
      </div>
    </div>
  </section>
</div>


    </div>
  );
}
